var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 1.65 10.06 5.898 4.49 1.65v.001l.007.006v5.948l5.498 4.34L15.5 7.771V1.65Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.93.617 15.501 1.65v6.122l4.498-3.453V2.24S19.453-.732 16.93.617Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 7.773v7.94h3.447s.981-.1 1.052-1.219V4.32L15.5 7.773Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.498 15.72V7.605l-.007-.006.007 8.121ZM4.491 1.651 3.07.624C.547-.726 0 2.244 0 2.244v2.081l4.491 3.274V1.651Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.491 1.651V7.6l.007.006V1.657l-.007-.006Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.326v10.175a1.227 1.227 0 0 0 1.052 1.22h3.447L4.49 7.598 0 4.326Z",
    fill: "#4285F4"
  })));
};
export default SvgGmail;